/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CategoryDeleteModalMutationVariables = {|
  id: string
|};
export type CategoryDeleteModalMutationResponse = {|
  +recipeCategoryDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type CategoryDeleteModalMutation = {|
  variables: CategoryDeleteModalMutationVariables,
  response: CategoryDeleteModalMutationResponse,
|};
*/


/*
mutation CategoryDeleteModalMutation(
  $id: ID!
) {
  recipeCategoryDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeCategoryDeletePayload",
    "kind": "LinkedField",
    "name": "recipeCategoryDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CategoryDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CategoryDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CategoryDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation CategoryDeleteModalMutation(\n  $id: ID!\n) {\n  recipeCategoryDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '66a2b76fd610f0f37a318fafe74c1655';

module.exports = node;
